import { Record, Set, Map } from 'immutable'
import { deserializePointOfInterest } from 'lib/api/records'
import _ from 'lodash'

export const EmbedData = Record({
  id: null,
  name: '',
  clubId: null,
  colors: [],
  urls: [],
  poiTags: [],
  enabledPoiTags: Set(),
  restrictivePoiTag: '',
  pois: [],
  rso: {
    route_ids: []
  },
  assets: null,
  boundsCriteria: '',

  embedSettings: Map(),

  routeTag: '',
  routeIds: []
})

export const serializeEmbedData = (embed) => {
  return Object.assign({}, {
    route_set_overview: {
      id: embed.get('id'),
      name: embed.get('name'),
      route_tag: embed.get('routeTag'),
      colors: embed.get('colors'),
      urls: embed.get('urls'),
      query_data: Object.assign({}, embed.get('rso').query_data, { tag_name: embed.get('routeTag') }),
      poi_tags: embed.get('poiTags').map(p => p.tag),
      default_tags_selected: embed.get('enabledPoiTags'),
      poi_tags_selected: [embed.get('restrictivePoiTag')],
      bounds_criteria: embed.get('boundsCriteria'),
      embed_settings: {
        bounding_box: embed.getIn(['embedSettings', 'boundingBox']),
        poi_bar: embed.getIn(['embedSettings', 'poiBar']),
        metric_units: embed.getIn(['embedSettings', 'metricUnits']),
        overlay: embed.getIn(['embedSettings', 'overlay'])
      }
    }
  })
}

export const deserializeEmbedData = (raw) => {
  const rawEmbedSettingsObj = (raw.route_set_overview && raw.route_set_overview.embed_settings) || {}

  // TODO: we shouldn't need to parse this json
  const rawEmbedSettings = _.isString(rawEmbedSettingsObj) ? JSON.parse(rawEmbedSettingsObj) : rawEmbedSettingsObj

  const embedSettings = Map({
    boundingBox: rawEmbedSettings.bounding_box,
    poiBar: rawEmbedSettings.poi_bar,
    metricUnits: rawEmbedSettings.metric_units,
    overlay: rawEmbedSettings.overlay
  }).filter((v, k) => v) // filter out keys that aren't set

  return EmbedData({
    id: raw.route_set_overview.id,
    name: raw.route_set_overview.name,
    colors: raw.colors,
    urls: raw.urls,
    poiTags: processTags(_.uniq(raw.poi_tags), raw.points_of_interest),
    rso: raw.route_set_overview,
    assets: raw.asset_details,
    enabledPoiTags: Set(raw.default_tags_selected),
    restrictivePoiTag: _.first(raw.poi_tags_selected),
    boundsCriteria: raw.route_set_overview.bounds_criteria,
    pois: raw.points_of_interest && raw.points_of_interest.map(p => normalizePOI(deserializePointOfInterest(p))),
    routeTag: raw.route_set_overview && raw.route_set_overview.query_data && raw.route_set_overview.query_data.tag_name,
    clubId: raw.route_set_overview && raw.route_set_overview.query_data && raw.route_set_overview.query_data.id,
    embedSettings: embedSettings
  })
}

const processTags = (tags, pois) => {
  const counts = {}
  tags.forEach(t => { counts[t] = 0 })
  pois.forEach(poi => {
    poi.tag_names.forEach(t => counts.hasOwnProperty(t) && (counts[t] += 1))
  })
  return tags.map(tag => ({ tag, count: counts[tag] }))
}

const normalizePOI = p => ({
  t: p.typeId,
  lat: p.lat,
  lng: p.lng,
  url: p.url,
  n: p.name,
  photoIds: p.photoIds,
  d: p.description,
  id: p.id,
  tagNames: p.tagNames
})
